import { FORMAT_DATE_BACK, formatDate, getPreviousDate, isEmpty } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { commonFiltersValue } from "@signals"
import { priceChangesPriceEvolutionFilters, pricingChangesEndDate, pricingChangesEvolutionCurrentPeriod } from "../../@signals"


export default function usePriceChangesShowEvolution(siteID, productID, skuID, externalSeller) {
    const newFilters = commonFiltersValue.peek()

	const handleClickShowPriceEvolution = (filters) => {
		filters.value = {}
		setTimeout(() => {
            pricingChangesEndDate.value = newFilters.currentSingleDate
            let startDate = formatDate(getPreviousDate({days: 6}, pricingChangesEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

            pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

			filters.value = {
				...commonFiltersValue.peek(),
				startDate: startDate,
				endDate: pricingChangesEndDate.value,
				productID: productID,
				retailer: [siteID],
				sku: [skuID],
				externalSeller: externalSeller
			}
		}, 0.1)
	}
   
	return {
		isOpenPriceEvolutionChart: !isEmpty(priceChangesPriceEvolutionFilters.value) && priceChangesPriceEvolutionFilters.value['productID'] === productID,
		handleClickShowPriceEvolution
	}
}